import { render, staticRenderFns } from "./videoDialog.vue?vue&type=template&id=8bcd0c7a&scoped=true&"
import script from "./videoDialog.vue?vue&type=script&lang=js&"
export * from "./videoDialog.vue?vue&type=script&lang=js&"
import style0 from "./videoDialog.vue?vue&type=style&index=0&id=8bcd0c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcd0c7a",
  null
  
)

export default component.exports